import React from 'react';
import PropTypes from 'prop-types';
import { connect, useSelector } from 'react-redux';
import { Empty, List, Typography } from 'antd';
import moment from 'moment';
import 'moment-timezone';

import selectors from '../../store/selectors';
import { massPropTypes } from '../../propTypes/mass';
import { NoMassHourTooltip } from '../NoMassHourTooltip/NoMassHourTooltip';

import AddOfferingButton from './AddOfferingButton';
import { CannotAddOfferingDescription } from './CannotAddOfferingDescription';

const enhance = connect((state, { selectedDate }) => {
  return {
    isFetchingMasses: selectors.isFetchingMasses(state),
    massesForDate: selectors.getMassesForDay(selectedDate)(state),
  };
});

const locale = {
  emptyText: (
    <Empty
      image={Empty.PRESENTED_IMAGE_SIMPLE}
      description="Brak dostępnych Mszy Świętych w danym dniu"
    />
  ),
};

const MassOfferings = ({ selectedDate, massesForDate }) => {
  const now = moment();
  const timeZone = useSelector(selectors.selectTimeZone);

  const massOfferingMassRequestMinDate = useSelector(selectors.getMassOfferingMassRequestFromDate);

  return (
    <List
      header={
        massesForDate.length > 0 && (
          <div>Dostępne Msze Święte w dniu {selectedDate.format('DD.MM.YYYY')}</div>
        )
      }
      bordered
      dataSource={massesForDate}
      locale={locale}
      renderItem={mass => {
        const isMassDateInFuture = moment(mass.massDate).isAfter(now) || !mass.hasHour;
        const showAddOfferingButton =
          (mass.availableMassOfferings > 0 || mass.hasUnlimitedOfferings) &&
          isMassDateInFuture &&
          !mass.unavailableBecauseOfMinimumFromDate &&
          !mass.unavailableBecauseOfEvenDistribution;

        const massTime = mass.hasHour
          ? moment(mass.massDate).tz(timeZone).format('HH:mm')
          : 'bez godziny';

        return (
          <List.Item>
            <Typography.Text strong>
              {massTime}
              <NoMassHourTooltip mass={mass} />
              {mass.publicNote && (
                <>
                  <br />
                  <small> {mass.publicNote}</small>
                </>
              )}
            </Typography.Text>
            {showAddOfferingButton ? (
              <AddOfferingButton
                massId={mass.id}
                massDate={mass.massDate}
                availableMassOfferings={mass.availableMassOfferings}
              />
            ) : (
              <CannotAddOfferingDescription
                isMassDateInFuture={isMassDateInFuture}
                unavailableBecauseOfMinimumFromDate={mass.unavailableBecauseOfMinimumFromDate}
                unavailableBecauseOfEvenDistribution={mass.unavailableBecauseOfEvenDistribution}
                massOfferingMassRequestMinDate={massOfferingMassRequestMinDate}
              />
            )}
          </List.Item>
        );
      }}
    />
  );
};

MassOfferings.propTypes = {
  massesForDate: PropTypes.arrayOf(massPropTypes),
  selectedDate: PropTypes.object,
};

export default enhance(MassOfferings);
